import * as clsx from 'clsx'
import * as React from 'react'
import { FormControl, FormControlProps } from 'react-bootstrap'
import { useFormContext, useWatch } from 'react-hook-form'

interface Props {
  inputName: string
  formControlProps: FormControlProps | undefined
  type?: string
}

export const CustomFormControl = ({ inputName, formControlProps }: Props): JSX.Element => {
  const { register, control } = useFormContext()
  const value = useWatch({
    name: inputName,
    control,
  })

  return (
    <FormControl
      {...register(inputName)}
      {...formControlProps}
      className={clsx(
        'shadow-none form-control-height-lg font-size-sm form-control-with-status',
        { 'no-value': !value },
        formControlProps?.className,
      )}
      data-testid={`${inputName}-form-control`}
    />
  )
}
